import React, { useState } from 'react';

import ObjectSearch from './ObjectSearch';

import ObjectName from './ObjectName';
import Icon from '../compUtils/Icon';



function ObjectSelector(props) {


    const [objectSearchState, setObjectSearchState] = useState("INACTIVE")
    const [selectedState, setSelectedState] = useState({ "state": "default", "id": 0, "name": "xxx" })


    return (
        <span >
            {objectSearchState === "INACTIVE" ?
                <span>
                    {selectedState.state === "default" ?
                        <span><ObjectName url={props.url+props.defaultValue+"/"}/>{" "}</span>
                        :
                        selectedState.name+" "}
                    <a class="okwButton" onClick={() => { setObjectSearchState("ACTIVE") }}>
                        <Icon name="pen" />
                    </a>
                </span>
                :
                <ObjectSearch url={props.url} selectCallback={(result) => { setSelectedState({ "state": "selected", "id": result.id, "name": result.name }); setObjectSearchState("INACTIVE"); props.setInputState(result.id) }}></ObjectSearch>
            }
        </span>

    );
}

export default ObjectSelector;
